import { apiSlice } from "../../../features/api/apiSlice";

function pick(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}
function pickArr(res: any): any[] {
  const d = pick(res);
  return Array.isArray(d) ? d : [];
}

export const chiefModeratorApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ── Active executive set ────────────────────────────────────────────────
    cmGetActiveSet: builder.query<{ id: number; name: string; start_date: string; end_date: string } | null, void>({
      query: () => "/exam/chief-moderator/active-set",
      transformResponse: (res: any) => pick(res),
      providesTags: [{ type: "ChiefModeratorModerators" as const, id: "ACTIVE_SET" }],
    }),

    // ── Moderators ──────────────────────────────────────────────────────────
    cmGetModerators: builder.query<any[], void>({
      query: () => "/exam/chief-moderator/moderators",
      transformResponse: (res: any) => pickArr(res),
      providesTags: [{ type: "ChiefModeratorModerators" as const, id: "LIST" }],
    }),

    cmCreateModerator: builder.mutation<any, { user_id: string; name: string; email: string; phone?: string }>({
      query: (body) => ({ url: "/exam/chief-moderator/moderators", method: "POST", body }),
      invalidatesTags: [{ type: "ChiefModeratorModerators" as const, id: "LIST" }],
    }),

    cmDeleteModerator: builder.mutation<any, string>({
      query: (id) => ({ url: `/exam/chief-moderator/moderators/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "ChiefModeratorModerators" as const, id: "LIST" }],
    }),

    // ── Assignments ─────────────────────────────────────────────────────────
    cmGetAssignments: builder.query<any[], string | void>({
      query: (dietId) => `/exam/chief-moderator/assignments${dietId ? `?diet_id=${dietId}` : ""}`,
      transformResponse: (res: any) => pickArr(res),
      providesTags: (_, __, dietId) => [
        { type: "ChiefModeratorAssignments" as const, id: dietId ?? "ALL" },
      ],
    }),

    cmAssignCourse: builder.mutation<any, { moderator_id: string; course_id: string; diet_id: string }>({
      query: (body) => ({ url: "/exam/chief-moderator/assign-course", method: "POST", body }),
      invalidatesTags: (_, __, { diet_id }) => [
        { type: "ChiefModeratorAssignments" as const, id: diet_id },
      ],
    }),

    cmRemoveAssignment: builder.mutation<any, string>({
      query: (id) => ({ url: `/exam/chief-moderator/assignments/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "ChiefModeratorAssignments" as const, id: "ALL" }],
    }),

    // ── Results ─────────────────────────────────────────────────────────────
    cmGetResults: builder.query<any[], { dietId?: string; status?: string } | void>({
      query: (params) => {
        const q = new URLSearchParams();
        if ((params as any)?.dietId) q.set("diet_id", (params as any).dietId);
        if ((params as any)?.status) q.set("status", (params as any).status);
        const s = q.toString();
        return `/exam/chief-moderator/results${s ? `?${s}` : ""}`;
      },
      transformResponse: (res: any) => pickArr(res),
      providesTags: [{ type: "ChiefModeratorResults" as const, id: "LIST" }],
    }),

    cmGetBatchScores: builder.query<any[], string>({
      query: (id) => `/exam/chief-moderator/results/${id}/scores`,
      transformResponse: (res: any) => pickArr(res),
      providesTags: (_, __, id) => [{ type: "ChiefModeratorResults" as const, id }],
    }),

    cmAssignModerator: builder.mutation<any, { id: string; moderator_id: string }>({
      query: ({ id, moderator_id }) => ({
        url: `/exam/chief-moderator/results/${id}/assign-moderator`,
        method: "POST",
        body: { moderator_id },
      }),
      invalidatesTags: [{ type: "ChiefModeratorResults" as const, id: "LIST" }],
    }),

    cmForwardToChiefExaminer: builder.mutation<any, { id: string; comment: string }>({
      query: ({ id, comment }) => ({
        url: `/exam/chief-moderator/results/${id}/forward`,
        method: "POST",
        body: { comment },
      }),
      invalidatesTags: [{ type: "ChiefModeratorResults" as const, id: "LIST" }],
    }),

    // ── Courses ─────────────────────────────────────────────────────────────
    cmGetCourses: builder.query<any[], void>({
      query: () => "/exam/chief-moderator/courses",
      transformResponse: (res: any) => pickArr(res),
      providesTags: [{ type: "ChiefModeratorCourses" as const, id: "ALL" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCmGetActiveSetQuery,
  useCmGetModeratorsQuery,
  useCmCreateModeratorMutation,
  useCmDeleteModeratorMutation,
  useCmGetAssignmentsQuery,
  useCmAssignCourseMutation,
  useCmRemoveAssignmentMutation,
  useCmGetResultsQuery,
  useCmGetBatchScoresQuery,
  useCmAssignModeratorMutation,
  useCmForwardToChiefExaminerMutation,
  useCmGetCoursesQuery,
} = chiefModeratorApi;
